import * as React from 'react';
import { useState } from 'react';
import { ShoppingCart } from "../../models/ShoppingCart";
import { Card, Button, CardBody, CardTitle, Input } from 'reactstrap';
import { formatDate, formatUtcDateToLocal } from "../../components/shared/Utils";
import SearchOrderCard from '../Order/SearchOrderCard';
import { Order } from '../../models/Order';

function SeachCartCard(props: {
    cart: ShoppingCart,
    reorderInProgress: boolean,
    viewCart: (cart: ShoppingCart) => void,
    reorder: (order: Order) => void,
    selectedCardIds: (cartId: string) => void
}) {
    const { cart, viewCart, reorder, reorderInProgress, selectedCardIds } = props;

    return <React.Fragment>
        <Card className="mb-3 card shopping-cart-card">
            <div className="card-top d-flex">
                <div className="card-top-section form-check form-check-inline">
                    <Input
                        id={cart.CartId}
                        className="form-check-input"
                        title="Select cart to merge"
                        type="checkbox"
                        value="true"
                        onChange={() => selectedCardIds(cart.CartId)}
                    />
                </div>
                <div className="card-top-section cart-name">
                    <div className="cart-name-title">{cart.CartName}</div>
                </div>
                <div className="card-top-section pr-4 property-value">
                    <span className="label">Cart ID:</span>
                    <span className="value">{cart.CartId}</span>
                </div>
                <div className="card-top-section pr-4 property-value">
                    <span className="label">Cart Modified:</span>
                    <span className="value">{formatUtcDateToLocal(cart.CartModified)}</span>
                </div>
                <div className="card-top-section property-value">
                    <span className="label">User Email:</span>
                    <span className="value">{cart.UserId}</span>
                </div>
                <div className="card-top-section section-angle-toggle d-flex align-items-center">
                    <Button
                        color="primary"
                        outline
                        className="rounded-0 btn btn-reorder"
                        onClick={() => { viewCart(cart); }}
                    >
                        View Cart
                    </Button>
                </div>
            </div>
        </Card>
        <>
            {cart.Orders && cart.Orders.length > 0 && cart.Orders.map((order, index) => {
                return <Card className="mb-3" key={order.Id}>
                    <CardBody>
                        <CardTitle tag="h5" className="cart-heading-title">
                            {order.PartnerName}
                        </CardTitle>
                        <div className="order-card-wrapper">
                            <SearchOrderCard order={order} reorder={reorder} reorderInProgress={reorderInProgress} />
                        </div>
                    </CardBody>
                </Card>

            })}
        </>
    </React.Fragment>
}

export default SeachCartCard;